import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { ElementRow } from './treelist.model';
import { TreelistEventService } from './treelist-event.service';
import { TreelistRest } from './treelist.rest';
//import { fakeRoles } from './fakeTreelistData';

@Component({
  selector: 'app-treelist',
  templateUrl: './treelist.component.html',
  styleUrls: ['./treelist.component.css']
})
export class TreelistComponent implements OnInit {
    
  @Input() apiPath: string;  

  @Output() onElementSelected = new EventEmitter<any>();

  private selectSubscription: Subscription;
  private selectedElement: ElementRow;
  private elements: ElementRow[] = [];

  constructor(
    private treelistEventService: TreelistEventService,
    private rest: TreelistRest
  ) { 
    this.selectSubscription = treelistEventService.selectElement$.subscribe(selectedRow => this.onSelectRow(selectedRow));
    }

  ngOnInit() {

    //this.elements = fakeRoles;
    if(this.apiPath)    {
    this.rest.getFirstLevelElements(this.apiPath).subscribe(elements => this.elements = elements);
    }
  }

  private onSelectRow(row: ElementRow){
    if(this.selectedElement){
      this.selectedElement.isSelected = false;
    }
    this.selectedElement = row;
    row.isSelected = true;

    if(this.selectedElement.id > 0 && this.selectedElement.guid == null)
    {
      this.onElementSelected.emit(this.selectedElement.id);
    }
    else if(this.selectedElement.guid.length > 0)
    {
      this.onElementSelected.emit(this.selectedElement.guid);
    }
  }

}
